import { IContact } from '@sales-center/common'
import {
  createEntityAdapter,
  createSlice,
  PayloadAction,
} from '@reduxjs/toolkit'
import { createContact, updateContact } from './api'

const contactAdapter = createEntityAdapter<IContact>({
  sortComparer: (a, b) => a.firstName.localeCompare(b.firstName),
})

export const initialState = {
  contacts: contactAdapter.getInitialState(),
}

export const contact = createSlice({
  name: 'contact',
  initialState,
  reducers: {
    addContact: (state, { payload }: PayloadAction<IContact>) => {
      contactAdapter.addOne(state.contacts, payload)
    },
    removeContact: (state, { payload }: PayloadAction<number>) => {
      contactAdapter.removeOne(state.contacts, payload)
    },
  },
  extraReducers: (builder) => {
    builder.addCase(createContact.fulfilled, (state, { payload }) => {
      contactAdapter.addOne(state.contacts, payload as IContact)
    })

    builder.addCase(updateContact.fulfilled, (state, { payload }) => {
      contactAdapter.upsertOne(state.contacts, payload as IContact)
    })
  },
})
